module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_remer",
    attrs: {
      "epub:type": "acknowledgments",
      "role": "doc-acknowledgments"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XI",
      "role": "doc-pagebreak",
      "title": "XI"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev3"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITH ALL MANNER")])])]), _vm._v("of ideas and thoughts on digital technology growing like wildflowers in me for years, I am indebted to the Louisville Institute and Westmont College for providing grant support and a sabbatical leave in 2017–2018 that allowed me to cultivate some blossoms in the proper garden of a book project.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This book would not exist without James Hunter, Elaine Ecklund, and Kelly Rutherford’s early cheerleading and belief that I had something worthwhile to say. I am profoundly grateful to my editor Jon Boyd, whose confidence in my writing and enthusiasm for this hybrid project let me spread my wings in full for the first time. Sincere thanks to Rebecca Carhart and the rest of the IVP Academic team for investing in this book and seeing it through production.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I owe a great deal to Drew Trotter, Richard Horner, and Karl Johnson for inviting me to speak to the Consortium of Christian Study Centers, thereby creating opportunities to share key ideas from this book at the University of Iowa, University of Minnesota, Duke University, University of North Carolina, and University of Virginia. I am also grateful for the invitations to engage communities at the Trinity School of Durham-Chapel Hill, St. Andrews Church, Free Methodist Church of Santa Barbara, the Lou Grant Parent-Child Workshop, Trinity Presbyterian Church of Charlottesville, Apologetics Canada, InterVarsity West Coast Faculty Conference, Center for Pastor Theologians, and Stanford Graduate InterVarsity Fellowship. Each occasion deepened my sense of what was at stake in writing this book. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XII",
      "role": "doc-pagebreak",
      "title": "XII"
    }
  }, [_vm._v("I am also grateful for the gift of stimulating conversations on technology and faith with Clay Cooke, Philip Lorish, Derek Schuurman, Edward Dixon, Jed Atkins, John Nicholson, Noah Toly, Andy Crouch, and Krista Boan.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To Jennifer West and Edward Song who lovingly to read the early chapters, thank you for each being a steady hand through this journey. I have been blessed by able undergraduate research assistants, Hailey Harper and Alesha Bond, and am indebted to Charis Guerzo who completed and cleaned up countless footnotes for the final manuscript. Special thanks to the Internet and Society students from spring 2019 who piloted The Freedom Project.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I am ever grateful for Meredith Whitnah, Nathan and Erica Huff, Amanda Sparkman, and Kya Mangrum whose kindness and camaraderie in the creative process have been a Godsend. And thank you, Sarah Baird, for a generous week of solitude and writing on Bainbridge Island.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Humble and heartfelt thanks to my patient children. And my parents, who faithfully prayed me through each deadline. Words fail to sufficiently hold all my love and gratitude to my husband Edward who took the kids camping and skiing when I needed to write, kept our household running through all my travel and spells of preoccupation, cooked countless meals that were unnecessarily delicious, and lovingly urged me forward each time I grew fainthearted.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Lastly, to the baristas at French Press/Dune, Santa Barbara Public Market, and Renaud’s: thank you for playing just the right music and fostering spaces of writing and imagination that grew sacred to me.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0